/**
 * BT-049 — Configuration backend staging / mode hybride.
 */

export const BACKEND_AUTH_KEY = "karate-backend-auth-v1";
export const BT_ID = "BT-GSD-KARATE-VALIDATION-STAGING-LIVE-AVANT-GILLES-057";
export const LEGACY_BT_ID = "BT-GSD-KARATE-ROBOT-HUMAIN-REPETITION-GENERALE-GILLES-056";
export const LEGACY_BT_IDS = [
  "BT-GSD-KARATE-ROBOT-HUMAIN-REPETITION-GENERALE-GILLES-056",
  "BT-GSD-KARATE-GABARIT-LISTE-OFFICIELLE-GILLES-055",
  "BT-GSD-KARATE-COMPTES-OFFICIELS-GILLES-PREPARATION-054",
  "BT-GSD-KARATE-COMPTES-REELS-STAGING-SECURISATION-053",
  "BT-GSD-KARATE-POSTGRESQL-STAGING-DISTANT-052",
  "BT-GSD-KARATE-CRUD-BACKEND-ESPACES-ROLES-MVP-051",
  "BT-GSD-KARATE-BACKEND-REEL-STAGING-MVP-049",
];

export function getBackendApiUrl() {
  const url = import.meta.env.VITE_KARATE_BACKEND_URL || "";
  return url.replace(/\/$/, "");
}

export function isBackendConfigured() {
  return Boolean(getBackendApiUrl());
}

/** @returns {'local'|'hybrid'|'backend'} */
export function getDataMode() {
  const mode = import.meta.env.VITE_KARATE_DATA_MODE || "local";
  if (mode === "backend" || mode === "hybrid") return mode;
  return "local";
}

export function isHybridDataMode() {
  return isBackendConfigured() && getDataMode() !== "local";
}

export function allowDemoAuthFallback() {
  return import.meta.env.VITE_KARATE_ALLOW_DEMO_FALLBACK !== "false";
}

import { STAGING_EMAILS } from "@/content/backendStagingMessages049.js";

export const STAGING_ACCOUNTS_DOC = {
  gilles: { identifier: "gilles.lavigne", email: STAGING_EMAILS.gilles, role: "hanshi" },
  marcel: { identifier: "marcel.charette", email: STAGING_EMAILS.marcel, role: "student" },
  natalie: { identifier: "natalie.lavigne", email: STAGING_EMAILS.natalie, role: "student" },
  parent: { identifier: "parent.demo", email: STAGING_EMAILS.parentDemo, role: "parent", isDemo: true },
  sempai: { identifier: "responsable1", email: STAGING_EMAILS.responsable1, role: "assistant" },
};

export const BACKEND_WIRED_ZONES = [
  "auth",
  "admin-accounts-access",
  "admin-dashboard-stats",
  "admin-organisation",
  "admin-dojos-crud",
  "admin-instructeurs-crud",
  "admin-etudiants-crud",
  "admin-parents-read",
  "admin-audit-logs-read",
  "mon-espace-profile",
  "parent-linked-children",
  "sensei-dojo-scoped-read",
  "sempai-limited-read",
];

export const STILL_LOCAL_DEMO_ZONES = [
  "documents",
  "preuves",
  "import-csv",
  "presences",
  "paiements",
  "communications",
  "progression-ceintures",
  "titres-validation-ui",
  "account-requests",
  "official-list-prep",
  "shotokan-black-dragon-module",
];
